// extracted by mini-css-extract-plugin
module.exports = {"lia-logo":"BrandLogo_lia-logo__9HhbP","lia-loading":"BrandLogo_lia-loading__nVP_5","lia-khoros-logo":"BrandLogo_lia-khoros-logo__5WZsD"};